import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';
import { PostCall } from '../../../hooks/api/usePostCall';
import { Subheader } from '../post-call-form';

export interface FeelingStepProps {
  postCall?: PostCall;
  className?: string;
}

export const FeelingStep: React.FC<FeelingStepProps> = ({ postCall, className }) => {
  const { control } = useFormContext();

  return (
    <div className={twMerge('flex flex-col gap-6', className)}>
      <Subheader
        question={
          <>
            How are you feeling after your call with{' '}
            <span className="font-bold">{postCall?.call.listener_role.user.display_name}</span>?
          </>
        }
        postCall={postCall}
      />

      <div className="flex flex-col gap-3">
        <p className="text-body-gray font-['Albert_Sans'] text-sm font-normal leading-5">
          Select a number from 1-10 to indicate how you're feeling.
        </p>

        <Controller
          control={control}
          name="moodScore"
          render={({ field: { value, onChange } }) => (
            <div className="flex flex-col gap-3">
              <div className="grid grid-cols-10 gap-2.5 md:gap-2" style={{ width: 'fit-content' }}>
                {Array.from({ length: 10 }, (_, idx) => {
                  const scoreValue = idx + 1;
                  const selected = value === scoreValue;
                  return (
                    <button
                      key={scoreValue}
                      type="button"
                      onClick={() => onChange(scoreValue)}
                      className={twMerge(
                        selected ? 'bg-accent text-white' : 'bg-button-secondary text-muted-text-gray',
                        'flex h-9 w-9 items-center justify-center rounded-full text-sm font-medium shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)] transition-colors hover:opacity-80',
                      )}
                    >
                      {scoreValue}
                    </button>
                  );
                })}
                <span className="text-muted-text-gray col-start-1 whitespace-nowrap text-xs font-medium">Very Low</span>
                <span className="text-muted-text-gray col-start-10 mr-3 text-right text-xs font-medium">
                  Very Positive
                </span>
              </div>
            </div>
          )}
        />
      </div>
    </div>
  );
};
